<template> <!--TO DO! change hard coded lookup to api form lookup-->
    <div >
        <div class="row">
            <div class="col">
                <q-btn-toggle
                    spread
                    v-model="Form.AmountUnits"
                    toggle-color="primary"
                    :options="AmountUnitOptions"
                    @input="AmountUnitSelection(Form.AmountUnits)"
                />
            </div>
        </div>
        <div class="row" v-if="Form.AmountUnits==='Units'">
            <div class="col">
                <q-toggle
                    v-model="Form.RedeemAllUnits"
                    label="Redeem All Units"
                    left-label
                    @input="PopulateAllUnits()"
                />
            </div>
        </div>
        <br>
        <div class="row">
            <div bottom-slots class="col" v-if="Form.AmountUnits!=='Amount'">
                <q-input 
                outlined 
                v-model="Form.Units" 
                label="Units"
                lazy-rules
                :rules="[ val => val !== '' && val !== null && val >= 0 || 'Must more than 0', val => val <= parseFloat(BalanceUnit) || 'Must not more than ' + parseFloat(BalanceUnit).toFixed(2) + ' units']" 
                />
            </div>
            <div bottom-slots class="col" v-else-if="Form.AmountUnits==='Amount'">
                <q-input 
                outlined 
                @blur="Amount=false"
                v-model="Form.Amount" 
                v-if="Amount===true"
                label="Amount"
                :rules="[ val => val !== '' && val !== null && val !== 0 && Form.AmountUnits==='Amount', , val => val <= parseFloat(BalanceAmount) || 'Must not more than MYR' + parseFloat(BalanceAmount).toFixed(2)]"
                />

                <q-input 
                outlined 
                :value="Form.Amount| thousandSeparator" 
                @focus="Amount=true"
                v-if="Amount===false"
                label="Amount"
                />
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col">
                <q-select 
                    filled 
                    v-model="Form.PaymentInstruction" 
                    :options="PaymentInstructionOptions" 
                    label="Payment Instruction"
                    lazy-rules
                    :rules="[ val => val !== '' && val !== null ]" 
                />
            </div>
        </div>
        <br>
        <div>
            <div class="row">
                <div class="col">
                    <q-select 
                        filled 
                        v-model="Form.PRSWithdrawalReason" 
                        :options="StoreStateLookup.Form.PRSWithdrawalReason" 
                        label="Withdrawal Reason"
                        @input="WithdrawalSetting(Form.PRSWithdrawalReason.value)"
                        lazy-rules
                        :rules="[ val => val !== '' && val !== null]"
                        map-options
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../store';
import { mapState, mapActions } from "vuex";
export default {
    name: 'FundTransactionRedemptionPRS',
    components: {
        
    },
    props: ['BalanceUnitA','BalanceUnitB', 'BalanceAmount'],
    data () {
        return {
            StoreStateProduct : store.state.Product,
            StoreStateCD : store.state.CD,
            StoreStateBAD : store.state.BAD,
            StoreStateLookup : store.state.Lookup,
            Form : {
                AmountUnits : 'Amount',
                Amount : 0,
                Units : 0,
                RedeemAllUnits : false,
                Instruction : '',
                PaymentInstruction : '',
                SwitchFundCode : '',
                PercSwitchOut : 0,
                SalesCharge : 0,
                Plan : 'PRS',
                PRSWithdrawalReason : ''
            },
            Amount : false,
            AddBankAccount : false,
            AmountUnitOptions : [
                {label: 'Amount', value: 'Amount'},
                {label: 'Units', value: 'Units'}
            ],
            PaymentInstructionOptions : []
        }
    },
    filters: {
		    thousandSeparator: function(value) {
		        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
		            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		        } else {
		            return value;
		        }
		    }
		  },
    methods : {
    ...mapActions(["UpdateFundList","GetListOfFund"]),
        FilterFund (val, update, abort) {
            update(() => {
                const needle = val.toLowerCase()
                this.StoreStateProduct.FundList = this.StoreStateProduct.FundOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        },
        AmountUnitSelection(selItem){
            this.Form.Units = 0;
            this.Form.Amount = 0;
        },
        PopulateAllUnits(){
            if(this.Form.RedeemAllUnits===true){
                this.Form.Units = this.TotalBalanceUnit;
            }
            else{
                this.Form.Units = 0
            }
        },
        WithdrawalSetting(value){
            if(value==='R003'){
                this.$q.dialog({
                    title: 'Message',
                    message: 'Must withdraw only using Account B',
                })
                this.Form.Plan = 'PRS30'
            }
            else
            if(value==='R004'){
                this.Form.Plan = 'PRS30'
            }
            else{
                this.Form.Plan = 'PRS'
            }
        }
    },
    mounted(){
        if(this.StoreStateCD.BankAccount.length<1){
            this.$q.dialog({
                title: 'Message',
                message: 'Kindly setup a bank account.',
            })
            .onOk(() => {
                this.$router.push({name : 'ClientBank'})
            })
            .onCancel(() => {
            })
            .onDismiss(() => {
                this.$router.push({name : 'ClientBank'})
            })
        }
        else{
            this.PaymentInstructionOptions = []
            for(var i=0; i<this.StoreStateCD.BankAccount.length; i++){
                this.PaymentInstructionOptions.push({
                    label : this.StoreStateCD.BankAccount[i].label + ' - ' + this.StoreStateCD.BankAccount[i].value,
                    value : this.StoreStateCD.BankAccount[i].value
                })
            }
            if(this.StoreStateCD.CustomerDetails.Age < 55){
                this.$q.dialog({
                    title: 'Message',
                    message: 'Investor is younger than 55 years old. Please ensure you have selected Pre-Retirement Withdrawal where appropriate.',
                })
                this.Form.PRSWithdrawalReason = 'R003'
                this.Form.Plan = 'PRS30'
            }
        }
    },
    computed : {
        BalanceUnit : function(){
            if(this.Form.PRSWithdrawalReason==='R003'){
                return this.BalanceUnitB
            }
            else{
                return this.BalanceUnitA + this.BalanceUnitB
            }
        },
        BalanceAmountPRS30 : function(){
            if(this.Form.PRSWithdrawalReason==='R003'){
                return this.BalanceAmount
            }
            else{
                return this.BalanceUnitA + this.BalanceUnitB
            }
        },
        TotalBalanceUnit : function(){
            return parseFloat(this.BalanceUnitA + this.BalanceUnitB).toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 2})
            
        }
    }
    
}
</script>